import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import { ACHType, CheckType } from "../types/genericType";
import { GridRowSelectionModel } from "@mui/x-data-grid";

export const getCheckDetails = async (): Promise<CheckType[]> => {
  try {
    const response: AxiosResponse<CheckType[]> = await axiosInstance.get(
      `/registers/${apiEndPoints.check}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getACHDetails = async (): Promise<ACHType[]> => {
  try {
    const response: AxiosResponse<ACHType[]> = await axiosInstance.get(
      `/registers/${apiEndPoints.ach}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const printACH = async (data: GridRowSelectionModel): Promise<void> => {
  try {
    await axiosInstance.post(`/reports/${apiEndPoints.ach}`, data);
  } catch (err) {
    throw err;
  }
};



export const updateCheckNumber = async (
  value: string
): Promise<void> => {
  try {
    const response: AxiosResponse<void> =
      await axiosInstance.post(`/registers/${apiEndPoints.check}`, value);
    return response?.data;
  } catch (err) {
    throw err;
  }
};
